import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowUp } from 'lucide-react';

/**
 * Floating helpers rendered on each divisional page.
 * - Top-left  "Back to Main" pill (always visible, links to /)
 * - Bottom-right "Back to Top" arrow button (appears after scroll)
 */
const PageNavHelpers = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowTop(window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Back to Main — fixed just below the sticky header */}
      <Link
        to="/"
        data-testid="back-to-main-btn"
        aria-label="Back to Reshadi main page"
        className="fixed z-40 top-[104px] md:top-[112px] left-4 md:left-6 inline-flex items-center gap-2 px-3.5 md:px-4 py-2 md:py-2.5 rounded-full bg-black/85 backdrop-blur-sm border border-[#3eb5a0]/40 text-white text-xs md:text-sm font-medium tracking-wide shadow-lg hover:bg-[#3eb5a0] hover:text-black hover:border-[#3eb5a0] transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-[#3eb5a0] focus:ring-offset-2 focus:ring-offset-black"
      >
        <ArrowLeft size={16} strokeWidth={2.4} />
        <span>Back to Main</span>
      </Link>

      {/* Back to Top — fixed bottom-right, shows after scroll */}
      <button
        type="button"
        onClick={scrollToTop}
        data-testid="back-to-top-btn"
        aria-label="Back to top"
        className={`fixed z-[60] bottom-5 right-5 md:bottom-8 md:right-8 w-11 h-11 md:w-12 md:h-12 rounded-full bg-[#3eb5a0] text-black shadow-xl border border-[#3eb5a0]/40 flex items-center justify-center transition-all duration-300 hover:bg-white hover:-translate-y-0.5 hover:shadow-2xl focus:outline-none focus:ring-2 focus:ring-[#3eb5a0] focus:ring-offset-2 focus:ring-offset-black ${
          showTop ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <ArrowUp size={20} strokeWidth={2.4} />
      </button>
    </>
  );
};

export default PageNavHelpers;
